export default __webpack_public_path__ + "static/fnp-da8e3b87e3b5f2ff1bcce5f344a496db.png";